export default __webpack_public_path__ + "static/media/01_word-choosing.df99e9dc.mp3";